import Swal from 'sweetalert2';

import Fetch from 'utils/fetch';
import { settings } from 'settings';

const fireSuccessAlert = () => {
  Swal.fire({
    position: 'center',
    icon: 'success',
    title: 'The partner deviation reporting is completed',
    showConfirmButton: false,
    timer: 1500,
  });
};

const fireErrorAlert = () => {
  Swal.fire({
    position: 'center',
    icon: 'error',
    title: 'There was an error',
    showConfirmButton: false,
    timer: 1500,
  });
};

export async function fetchPostDeviationAsync(
  orderId: string,
  deviationMessage: string,
  deviationStatus: 'OPEN' | 'CLOSED'
) {
  if (!orderId) return null;
  try {
    const response = await Fetch.post({
      url: `${settings.newApiUrl}/deviation/${orderId}`,
      body: { deviationMessage, deviationStatus },
    });

    if (response.ok) {
      fireSuccessAlert();
    } else {
      throw Error('POST Partner Deviation failed');
    }
  } catch (error) {
    const message = `Error posting partner deviation for order ${orderId}`;
    console.error(message, error);
    fireErrorAlert();
    throw error;
  }
}

export async function fetchPostMultipleDeviationAsync(
  orderIds: string[],
  deviationMessage: string,
  deviationStatus: 'OPEN' | 'CLOSED'
) {
  if (orderIds.length === 0) return null;
  try {
    const response = await Fetch.post({
      url: `${settings.newApiUrl}/deviation/orders`,
      body: { deviationOrders: orderIds, deviationMessage, deviationStatus },
    });

    if (response.ok) {
      fireSuccessAlert();
    } else {
      throw Error('POST Partner Deviation failed');
    }
  } catch (error) {
    const orders = orderIds.join(', ');
    const message = `Error posting partner deviation for orders ${orders}`;
    console.error(message, error);
    fireErrorAlert();
    throw error;
  }
}

export async function fetchPostCourierDeviationAsync(
  orderId: string,
  deviationMessage: string,
  deviationStatus: 'OPEN' | 'CLOSED'
) {
  try {
    const response = await Fetch.post({
      url: `${settings.newApiUrl}/deviation/courier/${orderId}`,
      body: { deviationMessage, deviationStatus },
    });

    if (response.ok) {
      fireSuccessAlert();
    } else {
      throw Error('POST Courier Deviation failed');
    }
  } catch (error) {
    const message = `Error posting courier deviation for order ${orderId}`;
    console.warn(message);
    fireErrorAlert();
    throw error;
  }
}

export async function fetchDeviationsWithAuthor(orderId: string) {
  const response = await Fetch.get({
    url: `${settings.newApiUrl}/order/${orderId}/deviations`,
  });

  if (response.ok) {
    return response.json();
  } else {
    const message = `Error fetching courier deviation for order ${orderId}`;
    console.warn(message, response);
    throw message;
  }
}
